import { render, staticRenderFns } from "./cots-extrabeds.vue?vue&type=template&id=519d1afd&scoped=true"
import script from "./cots-extrabeds.vue?vue&type=script&lang=js"
export * from "./cots-extrabeds.vue?vue&type=script&lang=js"
import style0 from "./cots-extrabeds.vue?vue&type=style&index=0&id=519d1afd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519d1afd",
  null
  
)

export default component.exports